module.exports = __webpack_public_path__ + "static/media/user.1ff47018.svg";